import { createReducer, on } from '@ngrx/store';
import { loadColorsSuccess } from './colors.actions';
import { IColorsList } from '@interfaces';

export interface ColorsState {
  colors: IColorsList[];
}

export const initialState: ColorsState = {
  colors: [],
};

export const colorsReducer = createReducer(
  initialState,
  on(loadColorsSuccess, (state, { colors }) => ({
    ...state,
    colors,
  })),
);

export function colorReducer(state: ColorsState | undefined, action: any) {
  return colorsReducer(state, action);
}
